/** @format */

import React from 'react';

interface BuildingIconProps {
  fill?: string;
  style?: React.CSSProperties;
}

const BuildingIcon: React.FC<BuildingIconProps> = ({ fill, style }) => {
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
      <path
        stroke={fill}
        strokeWidth="1.185"
        d="M.89 14.222V2.555c0-.206.068-.404.187-.55a.582.582 0 0 1 .449-.228h7.619c.168 0 .33.082.449.228.119.146.186.344.186.55v11.667"
      />
      <path
        fill={fill}
        d="M4.445 11.556a.889.889 0 0 1 1.778 0v2.667H4.445v-2.667ZM7.403 3.852H6.218a.296.296 0 0 0-.296.296v1.185c0 .164.133.296.296.296h1.185a.296.296 0 0 0 .297-.296V4.148a.296.296 0 0 0-.297-.296ZM7.403 6.815H6.218a.296.296 0 0 0-.296.297v1.185c0 .164.133.296.296.296h1.185a.296.296 0 0 0 .297-.296V7.112a.296.296 0 0 0-.297-.297ZM4.442 3.852H3.257a.296.296 0 0 0-.296.296v1.185c0 .164.133.296.296.296h1.185a.296.296 0 0 0 .297-.296V4.148a.296.296 0 0 0-.297-.296ZM4.442 6.815H3.257a.296.296 0 0 0-.296.297v1.185c0 .164.133.296.296.296h1.185a.296.296 0 0 0 .297-.296V7.112a.296.296 0 0 0-.297-.297Z"
      />
      <path
        stroke={fill}
        strokeWidth="1.185"
        d="M9.773 14.222V5.055c0-.162.04-.317.112-.432.071-.114.168-.179.27-.179h4.57c.102 0 .199.065.27.18.072.114.112.27.112.431v9.167"
      />
      <path
        fill={fill}
        d="M13.036 7.111h-1.185a.296.296 0 0 0-.296.297v1.185c0 .163.132.296.296.296h1.185a.296.296 0 0 0 .296-.296V7.408a.296.296 0 0 0-.296-.297ZM13.036 10.074h-1.185a.296.296 0 0 0-.296.296v1.186c0 .163.132.296.296.296h1.185a.296.296 0 0 0 .296-.296V10.37a.296.296 0 0 0-.296-.297Z"
      />
      <path stroke={fill} strokeWidth="1.185" d="M0 14.223h16" />
    </svg>
  );
};

export default BuildingIcon;
